import 'core-js/stable';
import Vue from 'vue';
import CoreuiVue from '@coreui/vue';
import App from './App';
import router from './router/index';
import { iconsSet as icons } from './assets/icons/icons.js';
import store from './store';
import firebase, { database } from 'firebase';
import axios from 'axios'
import VueAxios from 'vue-axios'
import "bootstrap/dist/css/bootstrap.min.css";
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import JsonCSV from 'vue-json-csv'
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

Vue.component('downloadCsv', JsonCSV);
Vue.use(VueAxios, axios);
Vue.use(CoreuiVue);
Vue.use(BootstrapVue);
window.Vue = require('vue').default;
window.VueResource = require('vue-router');
window.Vue.use(window.VueResource);
Vue.prototype.$log = console.log.bind(console);



const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDING_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT,
};
var filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};
Vue.filter('truncate', filter);

//firebase//
firebase.initializeApp(firebaseConfig);
// export const db=firebase.firestore();
const db = firebase.database();
const analytics = firebase.analytics();
console.log(analytics)
// export const db = firebaseApp.firestore();

//CSV Converter
export default firebase.messaging()


new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  template: '<App/>',
  components: {
    App
  }
})
